var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5248",
    "data-name": "Group 5248",
    transform: "translate(-370 -133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(79 -16)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(291 149)",
    fill: "#18beb3",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5221",
    "data-name": "Group 5221",
    transform: "translate(372.208 133.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6054",
    "data-name": "Path 6054",
    d: "M22.38,20.76A4.38,4.38,0,1,0,18,16.38,4.384,4.384,0,0,0,22.38,20.76Zm0-7.3a2.92,2.92,0,1,1-2.92,2.92A2.923,2.923,0,0,1,22.38,13.46Z",
    transform: "translate(-3.098)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6055",
    "data-name": "Path 6055",
    d: "M33.285,23.57A3.285,3.285,0,1,0,30,20.285,3.289,3.289,0,0,0,33.285,23.57Zm0-5.11a1.825,1.825,0,1,1-1.825,1.825A1.827,1.827,0,0,1,33.285,18.46Z",
    transform: "translate(-6.338 -1.35)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6056",
    "data-name": "Path 6056",
    d: "M26.947,27.46a5.109,5.109,0,0,0-2.555.684.715.715,0,0,0-.149.131,6.545,6.545,0,0,0-9.913-.009.688.688,0,0,0-.138-.122A5.111,5.111,0,0,0,6.527,32.57a.73.73,0,0,0,1.46,0,3.651,3.651,0,0,1,5.474-3.162.438.438,0,0,0,.055.018,6.521,6.521,0,0,0-.8,3.144.73.73,0,0,0,1.46,0,5.11,5.11,0,1,1,10.22,0,.73.73,0,0,0,1.46,0,6.52,6.52,0,0,0-.8-3.138.611.611,0,0,0,.07-.024A3.652,3.652,0,0,1,30.6,32.57a.73.73,0,0,0,1.46,0A5.116,5.116,0,0,0,26.947,27.46Z",
    transform: "translate(0 -3.78)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6057",
    "data-name": "Path 6057",
    d: "M12.311,17A3.285,3.285,0,1,0,15.6,20.285,3.289,3.289,0,0,0,12.311,17Zm0,5.11a1.825,1.825,0,1,1,1.825-1.825A1.827,1.827,0,0,1,12.311,22.11Z",
    transform: "translate(-0.675 -1.35)",
    fill: "#18beb3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsIcon);
export default __webpack_public_path__ + "static/media/teams-icon.4a1f947b3973870aac761f392c0ecf18.svg";
export { ForwardRef as ReactComponent };